import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer({ content }) {
  const tel = content.phone.replace(/[^+\d]/g, "");
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black text-neutral-400 py-16 border-t border-neutral-800" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4">
              {content.logo_url && (
                <img src={content.logo_url} alt="Logo" className="h-14 w-auto object-contain" />
              )}
              <div>
                <div className="font-display uppercase text-2xl font-black text-white tracking-tight">
                  {content.business_name}
                </div>
                <div className="text-sm mt-1">{content.tagline}</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed">
              Full-service home improvement contractors — framing, sheetrock, painting, kitchens, baths, decks, siding and more.
            </p>
          </div>

          <div>
            <div className="font-display uppercase font-bold text-white text-sm tracking-widest mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${tel}`} className="hover:text-orange-500 flex items-center gap-2" data-testid="footer-phone">
                  <Phone className="w-4 h-4" />{content.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${content.email}`} className="hover:text-orange-500 flex items-center gap-2">
                  <Mail className="w-4 h-4" />{content.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />{content.location}
              </li>
            </ul>
          </div>

          <div>
            <div className="font-display uppercase font-bold text-white text-sm tracking-widest mb-4">Quick Links</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="hover:text-orange-500">Services</a></li>
              <li><a href="#about" className="hover:text-orange-500">About</a></li>
              <li><a href="#gallery" className="hover:text-orange-500">Gallery</a></li>
              <li><a href="#contact" className="hover:text-orange-500">Contact</a></li>
              <li><a href="/admin/login" className="hover:text-orange-500" data-testid="footer-admin-link">Admin</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-neutral-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs">
          <div>© {year} {content.business_name}. All rights reserved.</div>
          <div>Licensed & insured contractor · Serving New York</div>
        </div>
      </div>
    </footer>
  );
}
